import Vue from 'vue'
import Element from 'element-ui'
import '@/style/element-variables.scss'
import locale from 'element-ui/lib/locale/lang/ja'

Vue.use(Element, { locale })


// Vue.use(Loading.directive);

// Vue.prototype.$loading = Loading.service;
// Vue.prototype.$msgbox = MessageBox;
// Vue.prototype.$alert = MessageBox.alert;
// Vue.prototype.$confirm = MessageBox.confirm;
// Vue.prototype.$prompt = MessageBox.prompt;
// Vue.prototype.$notify = Notification;
// Vue.prototype.$message = Message;
